// Alameen_News_Server seed (prisma/seed.js) page_id values.
// Keep this in sync with the server's seed table if it's re-run with different pages.
const PAGE_IDS = {
  PAGES: 1,
  ROLES: 2,
  USERS: 3,
  CATEGORIES: 4,
  SUBCATEGORIES: 5,
  NEWS: 6,
  TAGS: 7,
  MAIN_DASHBOARD: 8,
  PROFILE: 9,
  LANGUAGES: 10,
  BOT_CHANNELS: 11,
  BOT_RESPONSES: 12,
  BOT_TEMPLATES: 13,
};

export default PAGE_IDS;